import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { SnackbarService } from '@core/services/snackbar.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DotsSpinnerComponent } from '@shared/components/dots-spinner/dots-spinner.component';

@Component({
  imports: [
    ReactiveFormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    TranslateModule,
    DotsSpinnerComponent,
  ],
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
})
export class ForgotPasswordComponent {
  public readonly forgotPasswordForm: FormGroup;
  public isEmailSent = false;
  public sendingEmail = false;

  private readonly formBuilder = inject(FormBuilder);
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);
  private readonly snackBarService = inject(SnackbarService);
  private readonly translate = inject(TranslateService);

  constructor() {
    this.forgotPasswordForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  public async onSubmit(): Promise<void> {
    if (this.forgotPasswordForm.invalid) {
      return;
    }

    try {
      const email = this.forgotPasswordForm.get('email')?.value;
      this.sendingEmail = true;
      await this.authService.forgotPassword(email);
      this.isEmailSent = true;
    } catch {
      this.snackBarService.openError(
        this.translate.instant('pages.login.snackbar.passwordResetError'),
        this.translate.instant('shared.close'),
      );
      this.sendingEmail = false;
    }

    if (this.isEmailSent) {
      this.router.navigate(['/auth/login'], { state: { afterPasswordForgot: true } });
    }
  }

  public backToSignIn(): void {
    this.router.navigate(['/auth/login']);
  }
}
